import sdl from '@jds/react-generated-sdl/JDSRadioButton';
import type { JDSRadioButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputRadioProps } from '../logic';

const Component = (props: InputRadioProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    checked = false,
    size = 'medium',
    disabled = false,
    ariaLabel = props.label?.toString(),
    _ariaChecked = props.checked?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { checked, size, disabled, ariaLabel, _ariaChecked, ...rest },
    'JDSRadioButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputRadio = withLogic(Component) as React.FC<InputRadioProps> & {
  slotName?: string;
};

InputRadio.displayName = 'InputRadio';
InputRadio.slotName = 'jds_radio_button';

export { InputRadio, type JDSRadioButtonProps };
